import { render, staticRenderFns } from "./customClass-editor.vue?vue&type=template&id=c25839e0&scoped=true"
import script from "./customClass-editor.vue?vue&type=script&lang=js"
export * from "./customClass-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25839e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c25839e0')) {
      api.createRecord('c25839e0', component.options)
    } else {
      api.reload('c25839e0', component.options)
    }
    module.hot.accept("./customClass-editor.vue?vue&type=template&id=c25839e0&scoped=true", function () {
      api.rerender('c25839e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/customClass-editor.vue"
export default component.exports